// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';
import Radium from '../../../styling/rostelecom-radium';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../../styling/rostelecom-styles-store';
import { IWindowSizeStoreState } from '../../../../../../services/window-size/window-size-store';
import { IReactRadiumFreeStyles } from '../../../../../base/radium-types';

export interface ILoginPageProps extends React.Props<LoginLogo> {
    styleParams: IRostelecomStyleParamsStoreState;
    windowSize: IWindowSizeStoreState;
    wrapperHeight: number;
}

@Radium
class LoginLogo extends InternationalizedComponent<ILoginPageProps, {}> {
    private getStyles(): IReactRadiumFreeStyles {
        // const styleParams = this.props.styleParams;
        const width = 256;
        return {
            logoOuter: {
                fontSize: 0,
                heightFix: this.props.wrapperHeight,
                lineHeight: `${this.props.wrapperHeight}px`
            },
            imgOuter: {
                heightFix: this.props.wrapperHeight,
                width,
                lineHeight: `${this.props.wrapperHeight}px`,
                paddingLeftFix: 19
            },
            img: {
                display: 'inline-block',
                maxWidth: '100%',
                maxHeight: '100%',
                height: 'auto',
                width: 'auto',
                verticalAlign: 'middle'
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const styles = this.getStyles();
        const styleParams = this.props.styleParams;
        return (
            <div key="logo-outer" style={styles.logoOuter}>
                <div key="logo" style={styles.imgOuter}>
                    <img src={styleParams.customerLogo} style={styles.img} />
                </div>
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoginLogo;
